/* RW3 2026-10-02 (staging): in-stock alternatives for sold-out sizes + bulk-tier summary lines.
   Tier numbers are never hard-coded: they are read from the Bulk Tier Pricing app's own
   quantity-breaks table (on the PDP) or from /products/<handle>?view=rww-tiers (cards). */
(function () {
  'use strict';
  if (window.__rwwStockHelp) return;
  window.__rwwStockHelp = true;

  function frac(s) {
    s = String(s || '').replace(/["″]/g, '').trim();
    if (!s) return NaN;
    var whole = 0, m = s.match(/^(\d+)-(\d+\/\d+)$/);
    if (m) { whole = +m[1]; s = m[2]; }
    if (s.indexOf('/') > -1) { var p = s.split('/'); return whole + (+p[0]) / (+p[1]); }
    return whole + parseFloat(s);
  }
  function dims(title) {
    var m = /([\d\/-]+)"\s*OD\s*x\s*([\d\/-]+)"\s*ID\s*x\s*([\d\/-]+)"\s*Thick/i.exec(title || '');
    if (m) return { od: frac(m[1]), id: frac(m[2]), t: frac(m[3]), s: m[1] + '" OD x ' + m[2] + '" ID x ' + m[3] + '"' };
    m = /([\d\/-]+)"\s*OD\s*x\s*([\d\/-]+)"\s*Thick/i.exec(title || '');
    if (m) return { od: frac(m[1]), id: 0, t: frac(m[2]), s: m[1] + '" OD x ' + m[2] + '" disc' };
    return null;
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k)); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }

  /* ---------- in-stock source: the automated "In Stock" collection ---------- */
  var stockPromise = null;
  function inStock() {
    if (stockPromise) return stockPromise;
    var cached = store('rww-instock-v1');
    if (cached && cached.t > Date.now() - 10 * 60 * 1000) return (stockPromise = Promise.resolve(cached.items));
    stockPromise = fetch('/collections/in-stock/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        var items = [];
        (j.products || []).forEach(function (p) {
          var d = dims(p.title); if (!d) return;
          (p.variants || []).forEach(function (v) {
            if (!v.available) return;
            items.push({ h: p.handle, v: v.id, m: v.title, c: Math.round(parseFloat(v.price) * 100), od: d.od, id: d.id, t: d.t, s: d.s, disc: /disc/i.test(p.title) });
          });
        });
        store('rww-instock-v1', { t: Date.now(), items: items });
        return items;
      });
    return stockPromise;
  }

  function renderAlts(box) {
    if (box.dataset.done) return;
    box.dataset.done = '1';
    var list = box.querySelector('.rww-alts__list');
    var want = dims(box.dataset.title);
    var mat = (box.dataset.mat || '').toLowerCase();
    var handle = box.dataset.handle;
    if (!want || !list) { box.hidden = true; return; }
    inStock().then(function (items) {
      var wantDisc = want.id === 0;
      var scored = items.filter(function (x) { return x.h !== handle && x.disc === wantDisc; }).map(function (x) {
        // Bore (ID) matters most for fit, then thickness, then OD.
        var sc = Math.abs(x.id - want.id) * 3 + Math.abs(x.t - want.t) * 6 + Math.abs(x.od - want.od);
        return { x: x, sc: sc };
      }).sort(function (a, b) { return a.sc - b.sc; });
      var same = scored.filter(function (o) { return o.x.m.toLowerCase() === mat; }).slice(0, 3);
      var seen = {}; same.forEach(function (o) { seen[o.x.v] = 1; });
      var other = scored.filter(function (o) { return !seen[o.x.v] && o.x.m.toLowerCase() !== mat; }).slice(0, same.length ? 2 : 4);
      var rows = same.concat(other);
      if (!rows.length) { list.innerHTML = '<li>No close sizes in stock right now.</li>'; return; }
      list.innerHTML = rows.map(function (o) {
        var x = o.x, tags = [];
        if (x.id === want.id) tags.push('same ID');
        if (x.t === want.t) tags.push('same thickness');
        if (x.od === want.od) tags.push('same OD');
        return '<li><a href="/products/' + esc(x.h) + '?variant=' + x.v + '">' + esc(x.s) + ' · ' + esc(x.m) + '</a> <span class="rww-alts__p">' + money(x.c) + ' each</span>' +
          (tags.length ? ' <span class="rww-alts__tag">' + tags.join(', ') + '</span>' : '') + '</li>';
      }).join('');
      list.closest('.rww-alts__box').classList.add('is-ready');
    }).catch(function () {
      list.innerHTML = '<li><a href="/collections/in-stock">See every size in stock</a></li>';
    });
  }

  /* ---------- bulk tiers ---------- */
  function tiersFrom(root) {
    var out = [];
    (root || document).querySelectorAll('.qb-row[data-qb-min][data-qb-value]').forEach(function (r) {
      var min = parseInt(r.getAttribute('data-qb-min'), 10), val = parseFloat(r.getAttribute('data-qb-value'));
      var type = r.getAttribute('data-qb-type');
      if (type === 'percentage' && val >= 1 && min > 1 && !out.some(function (t) { return t.min === min; })) out.push({ min: min, pct: val });
    });
    return out.sort(function (a, b) { return a.min - b.min; });
  }
  function n(x) { return x.toLocaleString('en-US'); }
  function pdpLine(tiers) {
    var t = tiers, last = t[t.length - 1];
    var parts = t.slice(0, 2).map(function (x) { return x.pct + '% off ' + n(x.min) + '+'; });
    if (t.length > 2) parts.push('up to ' + last.pct + '% off ' + n(last.min) + '+');
    return '<strong>Bulk pricing:</strong> ' + parts.join(' · ') + ' pcs of this item, applied in the cart.';
  }
  function cardLine(tiers) {
    var f = tiers[0], last = tiers[tiers.length - 1];
    return 'Bulk: ' + f.pct + '% off ' + n(f.min) + '+' + (tiers.length > 1 ? ', up to ' + last.pct + '%' : '');
  }
  function fillPdpTier() {
    var el = document.querySelector('[data-rww-tier-line]');
    if (!el || el.dataset.done) return;
    var tiers = tiersFrom(document.querySelector('[data-qb-root]'));
    el.dataset.done = '1';
    if (tiers.length) { el.innerHTML = pdpLine(tiers); store('rww-tiers-v1', { t: Date.now(), tiers: tiers }); }
    else el.remove();
  }
  function fillCards() {
    var els = [].slice.call(document.querySelectorAll('[data-rww-card-tier]:not([data-done])'));
    if (!els.length) return;
    var apply = function (tiers) {
      els.forEach(function (el) { el.setAttribute('data-done', '1'); if (tiers && tiers.length) el.textContent = cardLine(tiers); });
    };
    var onPage = tiersFrom(document.querySelector('[data-qb-root]'));
    if (onPage.length) return apply(onPage);
    var c = store('rww-tiers-v1');
    if (c && c.t > Date.now() - 30 * 60 * 1000) return apply(c.tiers);
    var handle = els[0].getAttribute('data-rww-card-tier');
    fetch('/products/' + encodeURIComponent(handle) + '?view=rww-tiers', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var tiers = tiersFrom(doc);
        if (tiers.length) store('rww-tiers-v1', { t: Date.now(), tiers: tiers });
        apply(tiers);
      }).catch(function () { apply(null); });
  }

  // RW11 2026-10-03 speed: the sold-out alternatives need the 425 KB in-stock feed, so they wait for window load +
  // idle (their box keeps its reserved height meanwhile). The DOM watcher used to call run() on every animation
  // frame with any mutation (slideshow, preview bar, apps) from first paint on; it now starts after load and is
  // debounced to one run per 250 ms. Tier lines still fill at DOMContentLoaded and again at load.
  var loaded = document.readyState === 'complete';
  function idle(fn) { ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 200); }
  function alts() { document.querySelectorAll('[data-rww-alts]').forEach(renderAlts); }
  function run() {
    fillPdpTier();
    fillCards();
    if (loaded) alts();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // The theme swaps [data-dynamic-variant-content] blocks on variant change; re-run on the new nodes.
  document.addEventListener('on:variant:change', function () { setTimeout(run, 30); });
  function watch() {
    loaded = true;
    idle(run);
    var timer = 0;
    new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () { timer = 0; run(); }, 250);
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
  if (loaded) watch(); else window.addEventListener('load', watch, { once: true });
})();

/* RW7 2026-10-02 (staging): the size finder's "Request this size" link opens /pages/contact?rww_size=...
   This only pre-fills the message box when it is empty. No field name changes, nothing is submitted. */
(function () {
  try {
    var q = new URLSearchParams(location.search).get('rww_size');
    if (!q) return;
    var go = function () {
      var ta = document.querySelector('form[action*="/contact"] textarea');
      if (!ta || ta.value.trim()) return;
      ta.value = 'Size request (from the size finder): ' + q.slice(0, 120) + '\nQuantity needed: \n';
      ta.scrollIntoView({ block: 'center' });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  } catch (e) {}
})();
